<template>
  <div id="default-layout" class="h-full">
    <div class="grid h-full m-0">
      <div v-if="tenant" id="col_menu"
        class="col-2 p-0 bg-primary dark:surface-ground m-0 flex flex-column justify-content-between	">
        <PFMenu v-if="tenant != 'admin'" />
        <PFAdminMenu v-else />
        <div v-if="customLogo" class="text-center	">
          <img :src="customLogo" width="130" />
        </div>
      </div>
      <div class="col-offset-2 col-10 p-0">
        <PFHeader />
        <div class="content mx-4">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { find } from 'lodash-es';
const { user } = useGeneralStore();
const { public: config } = useRuntimeConfig();
const tenant = useTenant();
const { data: userData, signOut } = useAuth();
const { dynamicsSchema, dynamicFormSchema } = useSchema();
const customLogo = computed(() => {
  if(!userData.value?.user) return null;
  const currentTenant = find((userData.value.user as any).tenantsData as any[], { name: tenant });
  return currentTenant?.custom_logo || null;
});
</script>